import React, { useEffect } from "react";
import MenuImage from "../../components/MenuImage/MenuImage";
import "../IndexPage/IndexPage.css";

function SakePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div className="sakenew-background"></div>
      <div className="card-container">
        <MenuImage
          width="1500" height="2121"
          className="pdf-sake"
          es="img/sake.webp"
          en="img/sake_en.webp"
          ja="img/sake_ja.webp"
          alt="Sake"
        />
      </div>
    </div>
  );
}

export default SakePage;
